import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CustomerPaymentSettings} from 'components/manufacturer/Payments/entity/CustomerPaymentSettings';
import {DepositRule} from 'components/manufacturer/Payments/entity/Deposit';
import {RootState} from 'store/dashboard';

interface PaymentSettings {
    customerSettings?: CustomerPaymentSettings;
    depositRules?: DepositRule[];
    enableDepositRules?: boolean;
}

const initialState: PaymentSettings = {
    enableDepositRules: false,
};

const PaymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        enableDepositRulesSet: (state, {payload}: PayloadAction<boolean>) => {
            state.enableDepositRules = payload;
        },
        customerSettingsSet: (
            state,
            {payload}: PayloadAction<CustomerPaymentSettings>
        ) => {
            state.customerSettings = payload;
        },
        depositRulesSet: (state, {payload}: PayloadAction<DepositRule[]>) => {
            state.depositRules = payload;
        },
    },
});

export const {customerSettingsSet, depositRulesSet, enableDepositRulesSet} =
    PaymentSlice.actions;

export const selectCustomerSettings = (state: RootState) =>
    state.payment.customerSettings;
export const selectDepositRules = (state: RootState) =>
    state.payment.depositRules;
export const selectEnableDepositRules = (state: RootState) =>
    state.payment.enableDepositRules;

export default PaymentSlice.reducer;
